import API_URLS from '../config/apiConfig';
import apiClient from '../utils/apiUtils';
import { ErrorHandler } from '../utils/errorHandler';
import type { CountryStatesGroup, GroupedStatesResponse, SimpleState } from '../types/locations';

export const statesService = {
    getStates: async (): Promise<GroupedStatesResponse> => {
        try {
            const response = await apiClient.get(API_URLS.GET_ALL_STATES);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch states:', error);
            ErrorHandler.handleApiError(error, 'Failed to fetch states');
            throw error;
        }
    },
    updateState: async (stateCode: string, lotterySoftwareProvider: string | null): Promise<unknown> => {
        try {
            const response = await apiClient.patch(API_URLS.UPDATE_STATE(stateCode), {
                lottery_software_provider: lotterySoftwareProvider,
            });
            return response.data;
        } catch (error) {
            console.error('Failed to update state:', error);
            ErrorHandler.handleApiError(error, 'Failed to update state');
            throw error;
        }
    },
};

export type { CountryStatesGroup, GroupedStatesResponse, SimpleState };
